import { render, staticRenderFns } from "./link-brand.vue?vue&type=template&id=86a5a3d0"
import script from "./link-brand.vue?vue&type=script&lang=js"
export * from "./link-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports